module.exports = __webpack_public_path__ + "static/media/eating-table.1ca09d9a.svg";